var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-icon-wrapper",attrs:{"title":"Настроить таблицу"},on:{"click":_vm.emitOpenModal}},[_c('UiBaseIcon',{attrs:{"width":"20px","height":"20px","color":"#232323","icon-name":"cog"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }